/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Fragment } from 'react';
import Select from 'react-select';
import cn from 'classnames';
import onClickOutside from 'react-onclickoutside';

import './searchable-dropdown.scss';

class SearchableDropdown extends React.Component {
	state = { isOpen: false, companyName: undefined };

	handleClickOutside = () => {
		this.setState({ isOpen: false });
	};

	toggleOpen = () => {
		this.setState(state => ({ isOpen: !state.isOpen }));
	};

	onSelectChange = (value) => {
		const { handleSelect } = this.props;
		this.toggleOpen();
		this.setState({ companyName: value });
		handleSelect(value);
	};

	distinct = (acc, currentValue) => {
		if (!acc.find(partner => partner.id === currentValue.partner._id)) {
			acc.push({
				value: currentValue.partner.name,
				label: currentValue.partner.name,
				id: currentValue.partner._id,
			});
		}

		acc.sort((a, b) => {
			if (a.value > b.value) {
				return 1;
			}
			if (a.value < b.value) {
				return -1;
			}
			return 0;
		});

		return acc;
	}

	render() {
		const { isOpen, companyName } = this.state;
		const { companies } = this.props;

		const uniquePartners = companies.reduce(this.distinct, []);

		const allCompanies = { value: 'All', label: 'All' };
		uniquePartners.unshift(allCompanies);

		return (
			<Fragment>
				<Dropdown
					isOpen={isOpen}
					toggleOpen={this.toggleOpen}
					target={(
						<div
							className="by-company-btn"
							onClick={this.toggleOpen}
						>
							<span>{companyName ? companyName.value : 'All'}</span>
						</div>
					)}
				>
					<Select
						classNamePrefix="companies"
						backspaceRemovesValue={false}
						controlShouldRenderValue={false}
						hideSelectedOptions={false}
						isClearable={false}
						menuIsOpen={isOpen}
						onChange={this.onSelectChange}
						options={uniquePartners}
						placeholder="Search companies"
						tabSelectsValue={false}
						value={companyName}
					/>
				</Dropdown>

			</Fragment>

		);
	}
}

const Dropdown = ({
	children, isOpen, target,
}) => (
	<div className="dropdown-company">
		{target}
		{isOpen ? (
			<div className={cn('search-company', { open: isOpen })}>{children}</div>
		) : null}
	</div>
);

export default onClickOutside(SearchableDropdown);
